window.shopTranslations = [
  // --- Marketing Popup & Search (Stubborn Elements) ---
  { fr: "SUR VOTRE COMMANDE", en: "OFF YOUR ORDER" },
  { fr: "Votre email", en: "Your email" },
  { fr: "votre email", en: "your email" },
  { fr: "Demandez moi tout ...", en: "Ask me anything..." },
  { fr: "Demandez moi tout", en: "Ask me anything" },
  { fr: "NON, MERCI", en: "NO, THANKS" },
  { fr: "PROFITEZ DE -15%", en: "GET 15% OFF" },
  { fr: "LIVRAISON EXPRESS !", en: "EXPRESS SHIPPING!" },
  { fr: "Excluding products already discounted!", en: "Excluding products already discounted!" },

  // --- UI & Product Options ---
  { fr: "Nous allons confectionner la perruque avec plus de paquets de tissages", en: "We will make the wig with more bundles" },
  { fr: "Personnalisez votre produit :", en: "Customize your product:" },
  { fr: "Avis Clients", en: "Customer Reviews" },
  { fr: "Avis", en: "Review" },
  { fr: "Position de la raie", en: "Parting position" },
  { fr: "Raie au milieu", en: "Middle part" },
  { fr: "Pas de raie", en: "No part" },
  { fr: "Taille L", en: "Size L" },
  { fr: "Taille S", en: "Size S" },
  { fr: "Taille M \\(Recommandée\\)", en: "Size M (Recommended)" },
  { fr: "Densité 150% \\(Standard\\)", en: "Density 150% (Standard)" },
  { fr: "Densité 180%", en: "Density 180%" },
  { fr: "Densité 200%", en: "Density 200%" },
  { fr: "Sans Customisation", en: "Without Customization" },

  // --- Review Dropdown Options ---
  { fr: "Meilleures notes", en: "Highest ratings" },
  { fr: "Notes les plus basses", en: "Lowest ratings" },
  { fr: "Uniquement les photos", en: "Photos only" },
  { fr: "Photos en premier", en: "Photos first" },
  { fr: "Plus utiles", en: "Most helpful" },

  // --- Customer Review Text ---
  { fr: "La qualité est très bonne et les conseils fournis avant l'achat aussi. Par contre surtout ne pas prendre la livraison express car elle est aussi longue que la livraison normale. Quand je l'ai signalé rien a été fait alors que j'ai payé plus cher.", en: "The quality is very good and the advice provided before purchase too. On the other hand, especially do not take express delivery because it is as long as normal delivery. When I reported it nothing was done even though I paid more." },
  { fr: "Belle perruqe", en: "Beautiful wig" },
  { fr: "Très bien", en: "Very good" },
  { fr: "Jolie perruque j’adore", en: "Pretty wig I love it" },
  { fr: "Wouah la perruque est magnifique 🤩", en: "Wow the wig is magnificent 🤩" },
  { fr: "La closure est super j’ai pu me coiffé avec", en: "The closure is great I was able to style my hair with it" },
  { fr: "La longueur est respectée vraiment rien à redire ! Je suis satisfaite de mon achat !", en: "The length is respected really nothing to complain about! I am satisfied with my purchase!" },
  { fr: "Je suis vraiment satisfaite mon achat ! Les raw hair on une qualité incroyable ! Le prix est largement justifié ! J’ai commander 4 bundles raw hair body waves . Je vous remercie velvty paris ! ❤️", en: "I am really satisfied with my purchase! The raw hair has an incredible quality! The price is largely justified! I ordered 4 raw hair body waves bundles. Thank you Velvety Paris! ❤️" },
  { fr: "Les mèches sont incroyable!! Elles sont épaisse, il y a juste une petite odeur mais il suffit de bien les laver", en: "The locks are incredible!! They are thick, there is just a small smell but you just need to wash them well" },
  { fr: "Je vais en racheter très vite 😍", en: "I will buy more very soon 😍" },
  { fr: "Tissage au top coiffeuse parfaite", en: "Top weaving, perfect hairdresser" },
  { fr: "D'excellentes mèches. Tout simplement !", en: "Excellent locks. Simply!" },
  { fr: "Achat conforme à mes attentes.", en: "Purchase in line with my expectations." },
  { fr: "L'agente d'accueil (Diana) de même que la coiffeuse (Tessy) ont été réactives et professionnelles tout au long du processus.", en: "The receptionist (Diana) as well as the hairdresser (Tessy) were reactive and professional throughout the process." },
  { fr: "Je recommande la boutique.", en: "I recommend the boutique." },
  { fr: "Très bonne accueil à la boutique", en: "Very warm welcome at the boutique" },
  { fr: "Parfait extensions", en: "Perfect extensions" },
  { fr: "Très satisfaite merci", en: "Very satisfied thank you" },
  { fr: "Tisane de très bonne qualité", en: "Very high quality hair weave" },
  { fr: "Je suis très satisfaite ❤️", en: "I am very satisfied ❤️" },
  { fr: "Merci a toute l'équipe.", en: "Thanks to the whole team." },
  { fr: "Bien reçu pas encore tester.", en: "Well received, not tested yet." }
];